
import linq from "linq";
import { BaseVue } from "@newview/base-web";
const comForm = () => import("./comForm.vue"); //子组件引用父组件使用异步方式加载引入
import { Component, Prop, Watch } from "vue-property-decorator";
import { fabric } from "fabric";
import { DicBusinesstypeoptionApi } from "@newview/system-api";
// import { PicturelibraryApi } from "@newview/Cwlifecycle-api";
import { PicturelibraryApi } from "@newview/netsysdata-api";
import { FileApi } from "@newview/netsysconfig-api";
import axios from "axios";
import { watch } from "fs";
let OSS = require("ali-oss");
@Component({
  name: "ImageMark",
  components: { comForm },
})
export default class ImageMark extends BaseVue {
  @Prop({ default: 0 }) imgstart!: any;
  @Prop({ default: 0 }) imgModel!: any;
  bussinesstypeApi: DicBusinesstypeoptionApi = new DicBusinesstypeoptionApi();
  picturelibraryApi: PicturelibraryApi = new PicturelibraryApi();
  fileApi:FileApi = new FileApi();
  showModel = false;
  spinShow = false;
  selRootNodeInfo: any = {}; //类型表格被选中的行数据
  Basedata: any = "";
  myformModel: any = {
    uploadimg: "",
  };
  ossClient = new OSS({
    region: "oss-cn-hangzhou",
    accessKeyId: "IrNOgUFpgARau0pD",
    accessKeySecret: "yl77Y1XtVFkd74gEt63NyYNUIqFYGS",
    bucket: "trailroom",
  });

  myformItemData = [
    {
      label: "本地上传",
      type: "fileOne",
      prop: "uploadimg",
      model: "uploadimg",
      col: 24,
      btntxt: "本地上传",
    },
  ];
  fileParams = {
    Token: this.NewGuid(),
    CatalogPath: "/QA/ReportFill",
    GroupName: "默认",
    ProjectSKey:"22d22a8ae4fd97d0a7ab551128c872a4"
    // token: this.NewGuid(),
    // groupName: "质保资料",
    // catalogue: "erm",
  };
  headers = { Authorization: "Bearer " + sessionStorage.getItem("netToken") };
  canvas: any = "";
  width: any = "";
  height: any = "";
  orgWidth: any = ""; //原图宽度
  orgHeight: any = ""; //原图高度
  inputText: any = "";
  color: any = "#ff0000";
  fontSize: any = 18;
  ctxArr: any = {};
  count: any = 0;
  activeIndex: any = null;
  isSelect: any = false;
  fileStearm: any = "";
  operation: any = "text";
  imgInstance: any = "";
  img: any = "";
  CategoryList: any = [];
  ImgList: any = [];
  smodel: any = "";
  smodel2: any = "";
  fileList: any = [];
  imgurl: any = "";
  mUrl: any = "";
  firstId: any = "";
  secondId: any = "";
  dataurl: any = {};
  //获取图片分类
  async loadversionList() {
    
    // var data: any = await this.bussinesstypeApi.getDicOptions({typeCode:"1e5202f21505163320e830cab2d52089"});
    this.CategoryList = [{id:35,optionValue:"桥梁资料示意图"},{id:36,optionValue:"隧道资料示意图"}];
    
    this.SelectCategory(this.CategoryList[0].Token);
  }
  async SelectCategory(data) {
    if (data == undefined) {
      this.Basedata = "";
      this.init();
      return;
    }
    this.firstId = data;
    let GId = 0;
    if (!this.isNull(data)) {
      GId = data;
    }
    // var data: any = await this.picturelibraryApi.getPicturelibraryPage(1,10000, GId)
    // this.ImgList = data.data.records;
    var data: any = await this.picturelibraryApi.getEntitiesPage(1,10000, 'PicTypeCode='+GId)
    this.ImgList = data.result.Datas;
    this.$forceUpdate();
    if (this.ImgList.length > 0) {
      this.smodel2 = this.ImgList[0].Token;
      this.SelectImgEvent(this.smodel2);
      this.init();
    } else if (this.ImgList.length == 0) {
      this.smodel2 = "";
      this.Basedata = "";
      this.init();
      return;
    }
  }
  async SelectImgEvent(data, isChange: boolean = false) {
    // let aaa = await  this.fileApi.GetFiles(data)
    // if (aa)
    //

    this.fileList = [];
    let _this = this;
    this.spinShow = true;
    axios({
      method: "POST",
      url: "/UploadApi/File/GetFiles",
      params: { Token:data },
    }).then(function (res: any) {
      if (res.data.code === 200) {
        _this.fileList = res.data.result;
        if (isChange) _this.$emit("change", _this.fileList);
        // _this.secondId = _this.fileList[0].token;
        // // _this.imgurl = _this.fileList[0].Token + "_" + _this.fileList[0].Id;
        // // _this.Basedata = "/SystemApi/fileinfor/getInfoById?id=" + _this.fileList[0].id;
        // _this.Basedata = _this.ossClient.signatureUrl(_this.fileList[0].fileName);
        _this.secondId = _this.fileList[0].Token;
        _this.imgurl = _this.fileList[0].Token + "_" + _this.fileList[0].Id;
        _this.Basedata = "/UploadApi/File/Get?tokenId=" + _this.imgurl;
        _this.spinShow = false;
      }
    });
  }
  saveFun() {
    
    const url = this.canvas.toDataURL();
    var blob = this.dataURLtoBlob(url);
    this.dataurl = {
      firstId: this.firstId,
      secondId: this.secondId,
      url: url,
    };
    this.$emit("dataurl", this.dataurl);
  }
  uploadSuccess(res, file, fileList) {
    if (res.code!=200) {
      this.error("图片加载失败，请重新选择");
      return;
    } 
    this.success("图片上传完成");
    this.SelectImgEvent(this.fileParams.Token);
  }
  init() {
    //宽高自适应
    let img = this.ref("img");
    this.orgWidth = $(img).width();
    this.orgHeight = $(img).height();
    this.width = this.orgWidth > 780 ? 780 : this.orgWidth;
    this.height = this.orgHeight > 360 ? 360 : this.orgHeight;

    this.$nextTick(() => {
      if (!this.isNull(this.canvas)) {
        this.canvas.dispose();
      }
      this.canvas = new fabric.Canvas("canvas"); // 声明画布
      this.canvas.width = this.width; // 设置画布宽
      this.canvas.height = this.height; // 设置画布高
      const imgInstance = this.addOriginImage(this.canvas); // 添加背景图
      imgInstance.set("selectable", false); // 背景图不可选择
      this.onMouseDown(this.canvas); // 绑定点击新增文字事件
    });
  }
  addOriginImage(canvas) {
    this.img = new fabric.Image(this.ref("img"), {
      // 设置图片位置和样子
      left: 0,
      top: 0,
      width: this.orgWidth,
      height: this.orgHeight,
      scaleX: 1,
      scaleY: 1,
      angle: 0, // 设置图形顺时针旋转角度
    });
    this.img.scaleToWidth(this.width);
    this.img.scaleToHeight(this.height);
    this.img.crossOrigin = "anonymous";//添加此行anonymous必须小写
    canvas.add(this.img); // 加入到canvas中
    return this.img;
  }
  addText(canvas, color, pos) {
    let text = new fabric.IText("", {
      borderColor: "#ff0000", // 激活状态时的边框颜色
      editingBorderColor: "#ff0000", // 文本对象的边框颜色，当它处于编辑模式时
      left: pos.x,
      top: pos.y - 10,
      transparentCorners: true,
      fontSize: 14,
      fill: color || "#ff0000",
      padding: 5,
      cornerSize: 5, // Size of object's controlling corners
      cornerColor: "#ff0000",
      rotatingPointOffset: 20, // Offset for object's controlling rotating point
      lockScalingFlip: true, // 不能通过缩放为负值来翻转对象
      lockUniScaling: true, // 对象非均匀缩放被锁定
    });
    text.id = this.count;
    // 绑定选中事件
    text.on("selected", () => {
      this.activeIndex = text.id;
      this.isSelect = true;
    });
    canvas.add(text).setActiveObject(text); // 添加文字到画布上，并将文字置为激活状态
    text.enterEditing(); // 将文字置为编辑状态
    this.activeIndex = text.id;
    this.ctxArr[this.count] = text;
    this.count++;
  }
  delText(canvas, ctx) {
    canvas.remove(ctx);
  }
  onMouseDown(canvas) {
    canvas.on("mouse:down", (opt) => {
      console.log("this.activeIndex", this.activeIndex);
      const pos = opt.absolutePointer;
      // 执行文字操作
      const isText = () => {
        if (this.activeIndex === null) {
          // 如果当前没有选中元素，点击空白处添加文字
          this.addText(canvas, this.color, pos);
        } else {
          // 获取当前激活对象
          const o = canvas.getActiveObject();
          if (!o) {
            this.activeIndex = null;
          }
        }
      };
      switch (this.operation) {
        case "text":
          isText();
          break;
        default:
          isText();
      }
    });
  }
  onDel() {
    this.delText(this.canvas, this.ctxArr[this.activeIndex]);
    delete this.ctxArr[this.activeIndex];
  }
  onChangeColor() {
    // 获取当前激活对象
    const o = this.canvas.getActiveObject();
    if (o) {
      console.log("this.color", this.color);
      o.set("fill", this.color);
      this.canvas.renderAll();
    }
  }
  save() {
    // const url = this.canvas.toDataURL({
    //   format: 'jpeg',
    //   quality: 1
    // })
    const url = this.canvas.toDataURL();
    var blob = this.dataURLtoBlob(url);
    var file = this.blobToFile(blob, "截图.png");
    console.log(url);
    console.log(file);
    this.fileStearm = file;
    // 组装a标签
    let elink = document.createElement("a");
    // 设置下载文件名
    elink.download = "截图.png";
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    document.body.removeChild(elink);
  }
  dataURLtoBlob(dataurl) {
    var arr = dataurl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  // 将blob转换为file
  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  }
  @Watch("imgstart")
  imgstartChange(imgstart) {
    console.log("imgstart=>>", imgstart);
    this.smodel = "";
    this.smodel2 = "";
    if (imgstart == 1) {
      this.loadversionList();
      if (!this.isNull(this.canvas)) {
        // this.canvas.remove(this.img)
        this.$set(this.myformModel, "uploadimg", "");
        this.Basedata = "";
        this.canvas.clear();
        this.canvas.renderAll();
        this.canvas.requestRenderAll();
        this.canvas.rendercanvas();
      }
    }
  }
  @Watch("myformModel", { deep: true })
  myformModelChange() {
    console.log(this.myformModel);
    this.Basedata = this.myformModel.uploadimg;
    setTimeout(() => {
      if (!this.isNull(this.Basedata)) {
        this.init();
      }
    }, 100);
  }
  mounted() {
    this.loadversionList();
    console.log(this.imgModel.url);
    if (this.imgModel.firstId == "") {
      setTimeout(() => {
        this.Basedata = this.imgModel.url;
        this.myformModel.uploadimg = this.imgModel.url;
        console.log(this.myformModel);
        this.init();
      }, 500);
    } else {
      this.smodel = this.imgModel.firstId;
      this.smodel2 = this.imgModel.secondId;
      this.SelectCategory(this.smodel);
    }
  }
}
